import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup, DatePicker } from 'barnyard/components';


const InlineDateSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={DatePicker}
      required={true}
      {...other}
    />
  );
};

InlineDateSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineDateSelect.defaultProps = {
  label: 'Date',
  description: 'Select a Date',
};

export default memo(InlineDateSelect);
